import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || "Error de login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background grid-bg p-6" data-testid="admin-login-page">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-background to-accent/10" />
      <form onSubmit={submit} className="relative w-full max-w-md border border-border rounded-sm p-8 lg:p-10 bg-background shadow-2xl" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 rounded-sm bg-primary" />
          <span className="font-display font-black text-xl tracking-tighter">INFLUCAST</span>
        </div>
        <h1 className="font-display text-3xl font-black tracking-tight mb-2">Panel Admin</h1>
        <p className="text-sm text-muted-foreground mb-8">Ingresa con tus credenciales.</p>

        <div className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest font-bold mb-2 block">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="w-full h-11 px-4 bg-background border border-border rounded-sm focus:border-primary outline-none text-sm" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-bold mb-2 block">Contraseña</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="w-full h-11 px-4 bg-background border border-border rounded-sm focus:border-primary outline-none text-sm" />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full h-12 bg-primary text-primary-foreground font-bold uppercase tracking-widest text-sm rounded-sm hover:opacity-90 disabled:opacity-50 inline-flex items-center justify-center gap-2">
            <Lock className="w-4 h-4" /> {loading ? "Entrando..." : "Entrar"}
          </button>
        </div>
      </form>
    </div>
  );
}
